/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './batchDetailStart.tpl.html';
import './batchStart.tpl.html';
import './log.tpl.html';

/**
 * Module for the batchStart view.
 */
angular
  .module('mobile.batchstart', [])
  /**
   * Controller for the mobile batchStart template.
   */
  .controller('MobileBatchStartCtrl', function ($scope, $filter, $state, VIEW_STATES) {
    var NOBATCH = 'NONE';

    $scope.batches = [];
    $scope.showBatchOne = true;
    $scope.enableBatchAnimation = false;

    /**
     * Function that will pad the loaded batches to 12.
     */
    function setBatches() {
      // pad the array with empty objects to fill the bar.
      var batchesInfo = { rows: [] };
      while (batchesInfo.rows.length < 12) {
        batchesInfo.rows.push({
          status: NOBATCH
        });
      }
      $scope.batches = batchesInfo.rows;
      $scope.currentBatch = $scope.batches[0];
    }

    /**
     * Create a class list for the passed batch based on it's properties.
     *
     * @param {boolean} last True if this is the last batch in the list.
     *
     * @returns {string} A space delimited string of classes that are valid for the boink.
     */
    $scope.getBoinkClass = function (last) {
      var cls = '';

      if (last) {
        cls = cls + ' sbsf-boink-last';
      }
      return cls;
    };

    // Watches changes in backup state.
    $scope.$watch('backupInProgress ', function (newVal, oldVal) {
      if (newVal !== oldVal) {
        if (!$scope.backupInProgress) {
          $state.go(VIEW_STATES.MOBILE_HOME);
        }
      }
    });

    // load the batches history display.
    setBatches();
  })
  /**
   *  Controller for a mobile batch start detail view directive.
   */
  .controller('MobileBatchDetailStartCtrl', function ($scope, $filter) {
    var batchDate;

    /**
     * Returns the comma separated value for the number
     * @param {number} num - The number to apply the filter to.
     * @return {string} The number with commas applied.
     */
    $scope.getNum = function (num) {
      return $filter('number')(num);
    };

    batchDate = moment();
    $scope.batchDate = batchDate.format('ddd,  MMM D[,] YYYY');
    $scope.bigBoinkCls = 'sca-icon-cloud-boink';
    $scope.protectedPctCls = 'sbsf-blue';
    $scope.protectedPct = $filter('i18n')('NO_BACKUPS_YET_SHORT');
    $scope.batchWarn = $filter('i18n')('CHECK_BACK_LATER');
  })
  /**
   * The directive for the mobile batch start detail view.
   */
  .directive('mobileBatchStartDetail', function () {
    return {
      templateUrl: 'mobile/admin/start/batchDetailStart.tpl.html',
      scope: {
        batch: '=batch'
      },
      controller: 'MobileBatchDetailStartCtrl'
    };
  });
